import styled from '@emotion/styled';
import Checkbox from '@mui/material/Checkbox';

export const StyledCheckbox = styled(Checkbox)`
  border-radius: none;
  padding: 0;
  width: 22px;
  height: 22px;
  margin-top: 6px;

  &:hover {
    background: none;
  }
`;

StyledCheckbox.defaultProps = { disableRipple: true };

export const StyledIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: rgba(42, 221, 186, 0.16);
  border: 1px solid #2addba;
`;

export const StyledCheckedIcon = styled.span`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 22px;
  height: 22px;
  background: #2addba;
  border: 1px solid #2addba;
  color: white;
`;
